import React, { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ProfileContext } from "../../../Services/ProfileProvider";
import { alertSuccessMessage } from "../../../Services/CustomAlertModel";
import { ApiConfig } from "../../../Services/ApiServices/AuthAction/ApiConfig";

const Sidebar = () => {

  const navigate = useNavigate();
  const [isActive, setIsActive] = useState(false);
  const { setLoginDetails, userDetails } = useContext(ProfileContext);
  const KycStatus = userDetails?.kycVerified;

  const tokenExpire = () => {
    sessionStorage.clear();
    navigate("/");
    alertSuccessMessage("You have been logged out successfully");
    setLoginDetails({});
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      <nav id="sidebar" className={`sidebar-fixed ${isActive ? 'active' : ''}`}>
        <div className="d-flex align-items-center py-2 p-4">
          <Link className="navbar-brand" to="/dashboard"><img src="assets/images/logo.svg" width="190" alt="" className="navbar-brand" /></Link>
        </div>
        <hr />
        <div className="sidebar-header d-flex align-items-center p-3 pt-md-0">
          <img src={ApiConfig?.url + userDetails.user_image || "/assets/images/NEWUSER.jpeg"} alt="Profile"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "/assets/images/NEWUSER.jpeg";
            }}
          />
          <div className="ms-3 title">
            <h1 className="h5 mb-1">{userDetails?.name?.toUpperCase()}</h1>
            <h1 className="h6 mb-1">{userDetails?.user_unique_code}</h1>
            <span className={
              KycStatus === 0 ? "badge text-warning" :
                KycStatus === 1 ? "badge text-warning" :
                  KycStatus === 2 ? "badge text-success" : "badge text-danger"
            }>
              {KycStatus === 0 && "Update Kyc"}
              {KycStatus === 1 && "Kyc Pending"}
              {KycStatus === 2 && "Verified"}
              {KycStatus === 3 && "Rejected"}
            </span>
          </div>
        </div>
        <ul className="list-unstyled side_scroll">
          <li className="menu-heading">
            <h5 className="overline-title text-primary-alt"> Menu </h5>
          </li>
          <li className="sidebar-item">
            <Link className="sidebar-link" to="/dashboard">
              <span className="svg-icon svg-icon-sm svg-icon-heavy"><i className="ri-home-2-line"></i></span>
              <span>Dashboard</span>
            </Link>
          </li>
          <li className="sidebar-item">
            <a className="sidebar-link true" href="#exampledropdownDropdown5" data-bs-toggle="collapse">
              <span className="svg-icon svg-icon-sm svg-icon-heavy">
                <i className="ri-wallet-fill"></i>
              </span>
              <span className="wal_cont align-items-center d-flex justify-content-between">Wallet</span>
            </a>
            <ul className="collapse list-unstyled" id="exampledropdownDropdown5">
              <li><Link className="sidebar-link false" to={KycStatus === 2 ? "/deposit" : "/update_kyc"}>Deposit</Link></li>
              <li><Link className="sidebar-link false" to={KycStatus === 2 ? "/withdraw" : "/update_kyc"}>Withdrawal</Link></li>
            </ul>
          </li>

          <li className="sidebar-item">
            <Link className="sidebar-link false" to="/copy_trading">
              <span className="svg-icon svg-icon-sm svg-icon-heavy"><i className="ri-folder-chart-line"></i></span>
              <span>Copy Trading</span>
            </Link>
          </li>

          <li className="sidebar-item">
            <a className="sidebar-link true" href="#exampledropdownDropdown6" data-bs-toggle="collapse">
              <span className="svg-icon svg-icon-sm svg-icon-heavy">
                <i className="ri-secure-payment-line"></i>
              </span>
              <span>Operation History</span>
            </a>
            <ul className="collapse list-unstyled" id="exampledropdownDropdown6">
              <li><Link className="sidebar-link false" to="/deposit_history">Deposit History</Link></li>
              <li><Link className="sidebar-link false" to="/withdrawal_history">Withdrawal History</Link></li>
            </ul>
          </li>

          {/* Only render Update KYC if KYC is not verified */}
          {KycStatus !== 2 && (
            <li className="sidebar-item">
              <Link className="sidebar-link false" to="/update_kyc">
                <span className="svg-icon svg-icon-sm svg-icon-heavy"><i className="ri-user-line"></i></span>
                <span>Update Kyc</span>
              </Link>
            </li>
          )}

          <li className="sidebar-item">
            <Link className="sidebar-link false" to="/support-messages">
              <span className="svg-icon svg-icon-sm svg-icon-heavy"><i className="ri-message-2-line"></i></span>
              <span>Support</span>
            </Link>
          </li>

        </ul>

        <div className="sidebar-item px-3 mt-3">
          <button type="button" className="btn btn-danger w-100" onClick={tokenExpire}><span>Logout</span></button>
        </div>
      </nav>
      <div className="c_header">
        <div className="container-fluid">
          <div className="sec_nav">
            <div className="sec_logo">
              <img src="assets/images/logo.svg" width="190" alt="" className="navbar-brand d-block d-xl-none" />
            </div>
            <div className="nav_right">
              <div className="dropdown custom-dropdown">
                <button className="btn btn-icon btn-primary-light" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                  <i className="ri-settings-5-fill"></i>
                </button>
                <div className="dropdown-menu" data-bs-popper="static">
                  <Link className="header__el" to="/user_profile"><i className="ri-user-line"></i><div className="header__details">
                    <div className="header__title">Account Details</div>
                    <div className="header__content">Important account details</div></div>
                  </Link>
                  <Link className="header__el" to="/change_password">
                    <i className="ri-wallet-line"></i>
                    <div className="header__details"><div className="header__title">Change Password</div>
                      <div className="header__content">Strong Security to change password</div>
                    </div>
                  </Link>
                  <div className="header__el cursor-pointer" onClick={tokenExpire}>
                    <i className="ri-logout-circle-r-line"></i>
                    <div className="header__details">
                      <div className="header__title">Logout</div>
                    </div>
                  </div>
                </div>
              </div>
              <button className="navbar-toggler ms-2 d-block d-xl-none" onClick={() => setIsActive(prevState => !prevState)}>
                <span className="navbar-toggler-icon"></span>
              </button>

            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
